import type { OrderView } from '@khaddi/contracts';
import { useApi, useAsync } from '@khaddi/ui';
import { useEffect, useState } from 'react';
import { OPEN_FOR_SHIPPER, readActiveOrderId, rememberActiveOrder } from './activeOrder';

const POLL_MS = 5000;

/** `home.current`, or the order this shipper accepted while it was still being brewed. */
export const useActiveOrder = (shipperId: string, homeCurrent: OrderView | null): OrderView | null => {
  const api = useApi();
  const [trackedId, setTrackedId] = useState<string | null>(readActiveOrderId);
  const lookup = trackedId && !homeCurrent ? trackedId : null;
  const tracked = useAsync(() => (lookup ? api.orders.get(lookup) : Promise.resolve(null)), [lookup], { pollMs: lookup ? POLL_MS : undefined });

  const order = tracked.data;
  const stillMine = !!order && order.id === lookup && order.shipper?.id === shipperId && OPEN_FOR_SHIPPER.includes(order.status);

  useEffect(() => {
    if (homeCurrent) return;
    if ((order && order.id === lookup && !stillMine) || (lookup && tracked.error)) {
      rememberActiveOrder(null);
      setTrackedId(null);
    }
  }, [homeCurrent, order, lookup, stillMine, tracked.error]);

  return homeCurrent ?? (stillMine ? order : null);
};
